import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.018 4.806a.5.5 0 01.593-.385 7.75 7.75 0 014.148 2.395.5.5 0 01-.743.669 6.75 6.75 0 00-3.612-2.086.5.5 0 01-.386-.593zM18.74 9.286a.5.5 0 01.63.32 7.75 7.75 0 010 4.79.5.5 0 01-.95-.308 6.75 6.75 0 000-4.172.5.5 0 01.32-.63zM17.723 16.481a.5.5 0 01.037.706 7.75 7.75 0 01-4.149 2.395.5.5 0 11-.208-.978 6.75 6.75 0 003.613-2.086.5.5 0 01.707-.037zM6.278 16.481a.5.5 0 01.706.037 6.75 6.75 0 003.613 2.086.5.5 0 11-.208.978 7.75 7.75 0 01-4.148-2.395.5.5 0 01.037-.706zM5.26 9.286a.5.5 0 01.32.63 6.75 6.75 0 000 4.172.5.5 0 11-.95.309 7.75 7.75 0 010-4.79.5.5 0 01.63-.321zM10.982 4.806a.5.5 0 01-.385.593 6.75 6.75 0 00-3.613 2.086.5.5 0 11-.743-.67 7.75 7.75 0 014.148-2.394.5.5 0 01.593.385z",
      "clip-rule": "evenodd"
    })
  ]))
}